// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Harmattan:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Harmattan', Arial, sans-serif;
  background: #edebe0;
  min-height: 100vh;
}

.public-view-container {
  min-height: 100vh;
  padding: 0;
  direction: rtl;
  background: linear-gradient(135deg, #edebe0 0%, #d4d1c1 100%);
}

/* Wrapper للمحتوى */
.content-wrapper {
  width: 100%;
  margin: 0;
  background: white;
  min-height: 100vh;
}

/* الهيدر */
.public-header {
  background: linear-gradient(135deg, #002623 0%, #054239 50%, #428177 100%);
  padding: 50px 40px;
  text-align: center;
  position: relative;
  overflow: hidden;
  border-bottom: 5px solid #b9a779;
}

.public-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 20% 50%, rgba(237, 235, 224, 0.08) 0%, transparent 50%),
    radial-gradient(circle at 80% 50%, rgba(185, 167, 121, 0.08) 0%, transparent 50%);
  pointer-events: none;
}

.header-logos {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 60px;
  margin-bottom: 30px;
  position: relative;
  z-index: 1;
}

.republic-logo,
.ministry-logo {
  height: 75px;
  width: auto;
  object-fit: contain;
  filter: drop-shadow(0 5px 15px rgba(0, 0, 0, 0.35));
  transition: transform 0.3s ease;
}

.republic-logo:hover,
.ministry-logo:hover {
  transform: scale(1.03);
}

.header-titles {
  color: #edebe0;
  position: relative;
  z-index: 1;
}

.main-title {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 12px;
  color: #edebe0;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.5);
  letter-spacing: 1px;
  line-height: 1.4;
}

.sub-title {
  font-size: 2rem;
  font-weight: 600;
  color: #b9a779;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.4);
  letter-spacing: 0.5px;
}

/* بطاقة الموظف */
.employee-card {
  background: #fafafa;
  overflow: hidden;
  max-width: 1400px;
  margin: 0 auto;
  border-left: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
}

/* قسم الصورة والمعلومات الأساسية */
.card-header-section {
  background: linear-gradient(to bottom, #ffffff 0%, #f5f5f5 100%);
  padding: 60px 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 60px;
  position: relative;
  overflow: hidden;
  border-bottom: 3px solid #428177;
}

.card-header-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    linear-gradient(135deg, transparent 0%, rgba(66, 129, 119, 0.03) 100%);
  pointer-events: none;
}

.card-header-section::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 200px;
  height: 200px;
  background: radial-gradient(circle, rgba(185, 167, 121, 0.1) 0%, transparent 70%);
  border-radius: 50%;
}

.photo-container {
  position: relative;
  z-index: 1;
}

.employee-photo {
  width: 220px;
  height: 220px;
  border-radius: 8px;
  object-fit: cover;
  border: 5px solid #002623;
  box-shadow: 
    0 10px 40px rgba(0, 0, 0, 0.25),
    0 0 0 1px #428177;
  background: white;
  transition: transform 0.3s ease;
}

.employee-photo:hover {
  transform: scale(1.02);
}

.photo-placeholder {
  width: 220px;
  height: 220px;
  border-radius: 8px;
  background: linear-gradient(135deg, #3d3a3b 0%, #161616 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 5px solid #002623;
  box-shadow: 
    0 10px 40px rgba(0, 0, 0, 0.25),
    0 0 0 1px #428177;
}

.photo-placeholder span {
  color: #edebe0;
  font-size: 1.1rem;
  font-weight: 600;
}

.basic-info {
  text-align: right;
  position: relative;
  z-index: 1;
  flex: 1 1;
  max-width: 600px;
}

.employee-name {
  font-size: 3.2rem;
  font-weight: 700;
  color: #002623;
  margin-bottom: 0;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
  letter-spacing: 1px;
  line-height: 1.3;
}

.info-badge {
  display: inline-block;
  padding: 12px 35px;
  border-radius: 6px;
  font-size: 1.3rem;
  font-weight: 700;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 2px solid #002623;
}

.info-badge:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.employee-type {
  background: #b9a779;
  color: #002623;
}

/* أقسام المعلومات */
.info-section {
  padding: 50px 60px;
  border-bottom: 2px solid #e0e0e0;
  background: white;
  max-width: 1400px;
  margin: 0 auto;
}

.info-section:last-of-type {
  border-bottom: none;
}

.info-section:nth-child(even) {
  background: #fafafa;
}

.section-title {
  font-size: 2.2rem;
  font-weight: 700;
  color: #002623;
  margin-bottom: 35px;
  display: flex;
  align-items: center;
  gap: 15px;
  padding-bottom: 20px;
  border-bottom: 4px solid #002623;
  position: relative;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -4px;
  right: 0;
  width: 150px;
  height: 4px;
  background: #b9a779;
}

.title-icon {
  font-size: 2.4rem;
  color: #428177;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
  margin-top: 25px;
}

.info-item {
  background: white;
  padding: 25px 30px;
  border-radius: 8px;
  border-right: 4px solid #428177;
  border-left: 1px solid #e0e0e0;
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 38, 35, 0.08);
  position: relative;
  overflow: hidden;
}

.info-item::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 4px;
  height: 0;
  background: #054239;
  transition: height 0.3s ease;
}

.info-item:hover {
  transform: translateX(-5px);
  box-shadow: 0 4px 16px rgba(0, 38, 35, 0.15);
  border-right-color: #054239;
}

.info-item:hover::before {
  height: 100%;
}

.info-label {
  font-size: 1.05rem;
  font-weight: 700;
  color: #6b1f2a;
  text-transform: uppercase;
  letter-spacing: 1px;
  position: relative;
  z-index: 1;
}

.info-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #002623;
  position: relative;
  z-index: 1;
  line-height: 1.6;
}

.blood-type {
  color: #6b1f2a;
  font-weight: 800;
  font-size: 1.7rem;
}

/* قسم الباركود */
.barcode-section {
  padding: 60px 50px;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px;
  position: relative;
  border-top: 2px solid #e0e0e0;
  max-width: 1400px;
  margin: 0 auto;
}

.barcode-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    linear-gradient(135deg, transparent 0%, rgba(66, 129, 119, 0.03) 100%);
  pointer-events: none;
}

.qr-code {
  width: 240px;
  height: 240px;
  object-fit: contain;
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 
    0 8px 24px rgba(0, 0, 0, 0.15),
    0 0 0 3px #002623;
  border: 2px solid white;
  position: relative;
  z-index: 1;
  transition: transform 0.3s ease;
}

.qr-code:hover {
  transform: scale(1.03);
}

.barcode-text {
  font-size: 1.2rem;
  font-weight: 700;
  color: #002623;
  font-family: 'Courier New', monospace;
  letter-spacing: 4px;
  background: white;
  padding: 12px 30px;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1;
  border: 1px solid #e0e0e0;
}

/* الفوتر */
.public-footer {
  text-align: center;
  padding: 40px 40px;
  background: linear-gradient(135deg, #002623 0%, #054239 100%);
  position: relative;
  overflow: hidden;
  border-top: 5px solid #b9a779;
}

.public-footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 20% 50%, rgba(237, 235, 224, 0.05) 0%, transparent 50%),
    radial-gradient(circle at 80% 50%, rgba(185, 167, 121, 0.05) 0%, transparent 50%);
  pointer-events: none;
}

.public-footer p {
  color: #edebe0;
  font-size: 1.3rem;
  font-weight: 600;
  margin: 10px 0;
  position: relative;
  z-index: 1;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.4);
}

.footer-note {
  font-size: 1.1rem !important;
  color: #b9a779 !important;
  font-style: italic;
  font-weight: 500 !important;
}

/* شاشة التحميل */
.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 70vh;
  gap: 30px;
  padding: 40px;
  background: white;
}

.spinner {
  width: 100px;
  height: 100px;
  border: 8px solid #e0e0e0;
  border-top: 8px solid #002623;
  border-radius: 50%;
  animation: spin 1.2s linear infinite;
  box-shadow: 0 4px 16px rgba(0, 38, 35, 0.2);
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-spinner p {
  font-size: 1.8rem;
  font-weight: 700;
  color: #002623;
  letter-spacing: 0.5px;
}

/* رسالة الخطأ */
.error-card {
  background: white;
  border-radius: 12px;
  padding: 80px 60px;
  text-align: center;
  max-width: 700px;
  margin: 100px auto;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.2);
  border: 3px solid #6b1f2a;
  border-top: 8px solid #6b1f2a;
}

.error-icon {
  font-size: 7rem;
  margin-bottom: 30px;
  opacity: 0.9;
}

.error-card h2 {
  font-size: 2.4rem;
  font-weight: 700;
  color: #6b1f2a;
  margin-bottom: 20px;
  line-height: 1.4;
  letter-spacing: 0.5px;
}

.error-card p {
  font-size: 1.4rem;
  color: #3d3a3b;
  font-weight: 500;
  line-height: 1.7;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .employee-card,
  .info-section,
  .barcode-section {
    max-width: 100%;
  }

  .info-section {
    padding: 40px 40px;
  }

  .info-grid {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }
}

@media (max-width: 768px) {
  .content-wrapper {
    box-shadow: none;
  }

  .public-header {
    padding: 35px 25px;
  }

  .header-logos {
    gap: 35px;
    margin-bottom: 20px;
  }

  .republic-logo,
  .ministry-logo {
    height: 75px;
  }

  .main-title {
    font-size: 2rem;
  }

  .sub-title {
    font-size: 1.4rem;
  }

  .card-header-section {
    flex-direction: column;
    padding: 40px 25px;
    gap: 30px;
  }

  .basic-info {
    text-align: center;
    max-width: 100%;
  }

  .employee-photo,
  .photo-placeholder {
    width: 180px;
    height: 180px;
  }

  .employee-name {
    font-size: 2.2rem;
    text-align: center;
  }

  .info-section {
    padding: 35px 25px;
  }

  .section-title {
    font-size: 1.8rem;
    padding-bottom: 15px;
  }

  .section-title::after {
    width: 100px;
  }

  .info-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .info-item {
    padding: 20px 22px;
  }

  .qr-code {
    width: 200px;
    height: 200px;
  }

  .barcode-section {
    padding: 45px 25px;
  }

  .public-footer {
    padding: 35px 25px;
  }

  .error-card {
    margin: 50px 20px;
    padding: 50px 30px;
  }
}

@media (max-width: 480px) {
  .main-title {
    font-size: 1.6rem;
  }

  .sub-title {
    font-size: 1.2rem;
  }

  .employee-name {
    font-size: 1.9rem;
  }

  .info-value {
    font-size: 1.3rem;
  }

  .section-title {
    font-size: 1.5rem;
  }

  .info-label {
    font-size: 0.95rem;
  }

  .employee-photo,
  .photo-placeholder {
    width: 150px;
    height: 150px;
  }

  .qr-code {
    width: 170px;
    height: 170px;
  }

  .info-section {
    padding: 30px 20px;
  }

  .public-header {
    padding: 30px 20px;
  }
}

/* طباعة */
@media print {
  .public-view-container {
    background: white;
  }

  .content-wrapper {
    box-shadow: none;
  }

  .card-header-section::before,
  .public-header::before,
  .public-footer::before,
  .barcode-section::before {
    display: none;
  }

  .employee-card {
    page-break-inside: avoid;
  }

  .info-section {
    page-break-inside: avoid;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/PublicEmployeeView.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,cAAc;EACd,6DAA6D;AAC/D;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,0EAA0E;EAC1E,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;qFAEmF;EACnF,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mDAAmD;EACnD,+BAA+B;AACjC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,2CAA2C;EAC3C,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA,mCAAmC;AACnC;EACE,gEAAgE;EAChE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;0EACwE;EACxE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,iFAAiF;EACjF,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB;;qBAEmB;EACnB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB;;qBAEmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;EAC1C,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,8BAA8B;EAC9B,6BAA6B;EAC7B,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yBAAyB;EACzB,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;0EACwE;EACxE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB;;qBAEmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;EAClB,UAAU;EACV,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,kBAAkB;EAClB,6DAA6D;EAC7D,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;qFAEmF;EACnF,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,2CAA2C;AAC7C;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;;;IAGE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,2DAA2D;EAC7D;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;;IAEE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,UAAU;AACV;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;;IAIE,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Harmattan:wght@400;500;600;700&display=swap');\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Harmattan', Arial, sans-serif;\n  background: #edebe0;\n  min-height: 100vh;\n}\n\n.public-view-container {\n  min-height: 100vh;\n  padding: 0;\n  direction: rtl;\n  background: linear-gradient(135deg, #edebe0 0%, #d4d1c1 100%);\n}\n\n/* Wrapper للمحتوى */\n.content-wrapper {\n  width: 100%;\n  margin: 0;\n  background: white;\n  min-height: 100vh;\n}\n\n/* الهيدر */\n.public-header {\n  background: linear-gradient(135deg, #002623 0%, #054239 50%, #428177 100%);\n  padding: 50px 40px;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n  border-bottom: 5px solid #b9a779;\n}\n\n.public-header::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: \n    radial-gradient(circle at 20% 50%, rgba(237, 235, 224, 0.08) 0%, transparent 50%),\n    radial-gradient(circle at 80% 50%, rgba(185, 167, 121, 0.08) 0%, transparent 50%);\n  pointer-events: none;\n}\n\n.header-logos {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 60px;\n  margin-bottom: 30px;\n  position: relative;\n  z-index: 1;\n}\n\n.republic-logo,\n.ministry-logo {\n  height: 75px;\n  width: auto;\n  object-fit: contain;\n  filter: drop-shadow(0 5px 15px rgba(0, 0, 0, 0.35));\n  transition: transform 0.3s ease;\n}\n\n.republic-logo:hover,\n.ministry-logo:hover {\n  transform: scale(1.03);\n}\n\n.header-titles {\n  color: #edebe0;\n  position: relative;\n  z-index: 1;\n}\n\n.main-title {\n  font-size: 3rem;\n  font-weight: 700;\n  margin-bottom: 12px;\n  color: #edebe0;\n  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.5);\n  letter-spacing: 1px;\n  line-height: 1.4;\n}\n\n.sub-title {\n  font-size: 2rem;\n  font-weight: 600;\n  color: #b9a779;\n  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.4);\n  letter-spacing: 0.5px;\n}\n\n/* بطاقة الموظف */\n.employee-card {\n  background: #fafafa;\n  overflow: hidden;\n  max-width: 1400px;\n  margin: 0 auto;\n  border-left: 1px solid #e0e0e0;\n  border-right: 1px solid #e0e0e0;\n}\n\n/* قسم الصورة والمعلومات الأساسية */\n.card-header-section {\n  background: linear-gradient(to bottom, #ffffff 0%, #f5f5f5 100%);\n  padding: 60px 50px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 60px;\n  position: relative;\n  overflow: hidden;\n  border-bottom: 3px solid #428177;\n}\n\n.card-header-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: \n    linear-gradient(135deg, transparent 0%, rgba(66, 129, 119, 0.03) 100%);\n  pointer-events: none;\n}\n\n.card-header-section::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 200px;\n  height: 200px;\n  background: radial-gradient(circle, rgba(185, 167, 121, 0.1) 0%, transparent 70%);\n  border-radius: 50%;\n}\n\n.photo-container {\n  position: relative;\n  z-index: 1;\n}\n\n.employee-photo {\n  width: 220px;\n  height: 220px;\n  border-radius: 8px;\n  object-fit: cover;\n  border: 5px solid #002623;\n  box-shadow: \n    0 10px 40px rgba(0, 0, 0, 0.25),\n    0 0 0 1px #428177;\n  background: white;\n  transition: transform 0.3s ease;\n}\n\n.employee-photo:hover {\n  transform: scale(1.02);\n}\n\n.photo-placeholder {\n  width: 220px;\n  height: 220px;\n  border-radius: 8px;\n  background: linear-gradient(135deg, #3d3a3b 0%, #161616 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 5px solid #002623;\n  box-shadow: \n    0 10px 40px rgba(0, 0, 0, 0.25),\n    0 0 0 1px #428177;\n}\n\n.photo-placeholder span {\n  color: #edebe0;\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.basic-info {\n  text-align: right;\n  position: relative;\n  z-index: 1;\n  flex: 1;\n  max-width: 600px;\n}\n\n.employee-name {\n  font-size: 3.2rem;\n  font-weight: 700;\n  color: #002623;\n  margin-bottom: 0;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);\n  letter-spacing: 1px;\n  line-height: 1.3;\n}\n\n.info-badge {\n  display: inline-block;\n  padding: 12px 35px;\n  border-radius: 6px;\n  font-size: 1.3rem;\n  font-weight: 700;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  border: 2px solid #002623;\n}\n\n.info-badge:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);\n}\n\n.employee-type {\n  background: #b9a779;\n  color: #002623;\n}\n\n/* أقسام المعلومات */\n.info-section {\n  padding: 50px 60px;\n  border-bottom: 2px solid #e0e0e0;\n  background: white;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.info-section:last-of-type {\n  border-bottom: none;\n}\n\n.info-section:nth-child(even) {\n  background: #fafafa;\n}\n\n.section-title {\n  font-size: 2.2rem;\n  font-weight: 700;\n  color: #002623;\n  margin-bottom: 35px;\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  padding-bottom: 20px;\n  border-bottom: 4px solid #002623;\n  position: relative;\n}\n\n.section-title::after {\n  content: '';\n  position: absolute;\n  bottom: -4px;\n  right: 0;\n  width: 150px;\n  height: 4px;\n  background: #b9a779;\n}\n\n.title-icon {\n  font-size: 2.4rem;\n  color: #428177;\n}\n\n.info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n  gap: 30px;\n  margin-top: 25px;\n}\n\n.info-item {\n  background: white;\n  padding: 25px 30px;\n  border-radius: 8px;\n  border-right: 4px solid #428177;\n  border-left: 1px solid #e0e0e0;\n  border-top: 1px solid #e0e0e0;\n  border-bottom: 1px solid #e0e0e0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 38, 35, 0.08);\n  position: relative;\n  overflow: hidden;\n}\n\n.info-item::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 4px;\n  height: 0;\n  background: #054239;\n  transition: height 0.3s ease;\n}\n\n.info-item:hover {\n  transform: translateX(-5px);\n  box-shadow: 0 4px 16px rgba(0, 38, 35, 0.15);\n  border-right-color: #054239;\n}\n\n.info-item:hover::before {\n  height: 100%;\n}\n\n.info-label {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #6b1f2a;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  position: relative;\n  z-index: 1;\n}\n\n.info-value {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #002623;\n  position: relative;\n  z-index: 1;\n  line-height: 1.6;\n}\n\n.blood-type {\n  color: #6b1f2a;\n  font-weight: 800;\n  font-size: 1.7rem;\n}\n\n/* قسم الباركود */\n.barcode-section {\n  padding: 60px 50px;\n  background: #f5f5f5;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 25px;\n  position: relative;\n  border-top: 2px solid #e0e0e0;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.barcode-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: \n    linear-gradient(135deg, transparent 0%, rgba(66, 129, 119, 0.03) 100%);\n  pointer-events: none;\n}\n\n.qr-code {\n  width: 240px;\n  height: 240px;\n  object-fit: contain;\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: \n    0 8px 24px rgba(0, 0, 0, 0.15),\n    0 0 0 3px #002623;\n  border: 2px solid white;\n  position: relative;\n  z-index: 1;\n  transition: transform 0.3s ease;\n}\n\n.qr-code:hover {\n  transform: scale(1.03);\n}\n\n.barcode-text {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #002623;\n  font-family: 'Courier New', monospace;\n  letter-spacing: 4px;\n  background: white;\n  padding: 12px 30px;\n  border-radius: 6px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  position: relative;\n  z-index: 1;\n  border: 1px solid #e0e0e0;\n}\n\n/* الفوتر */\n.public-footer {\n  text-align: center;\n  padding: 40px 40px;\n  background: linear-gradient(135deg, #002623 0%, #054239 100%);\n  position: relative;\n  overflow: hidden;\n  border-top: 5px solid #b9a779;\n}\n\n.public-footer::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: \n    radial-gradient(circle at 20% 50%, rgba(237, 235, 224, 0.05) 0%, transparent 50%),\n    radial-gradient(circle at 80% 50%, rgba(185, 167, 121, 0.05) 0%, transparent 50%);\n  pointer-events: none;\n}\n\n.public-footer p {\n  color: #edebe0;\n  font-size: 1.3rem;\n  font-weight: 600;\n  margin: 10px 0;\n  position: relative;\n  z-index: 1;\n  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.4);\n}\n\n.footer-note {\n  font-size: 1.1rem !important;\n  color: #b9a779 !important;\n  font-style: italic;\n  font-weight: 500 !important;\n}\n\n/* شاشة التحميل */\n.loading-spinner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 70vh;\n  gap: 30px;\n  padding: 40px;\n  background: white;\n}\n\n.spinner {\n  width: 100px;\n  height: 100px;\n  border: 8px solid #e0e0e0;\n  border-top: 8px solid #002623;\n  border-radius: 50%;\n  animation: spin 1.2s linear infinite;\n  box-shadow: 0 4px 16px rgba(0, 38, 35, 0.2);\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loading-spinner p {\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: #002623;\n  letter-spacing: 0.5px;\n}\n\n/* رسالة الخطأ */\n.error-card {\n  background: white;\n  border-radius: 12px;\n  padding: 80px 60px;\n  text-align: center;\n  max-width: 700px;\n  margin: 100px auto;\n  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.2);\n  border: 3px solid #6b1f2a;\n  border-top: 8px solid #6b1f2a;\n}\n\n.error-icon {\n  font-size: 7rem;\n  margin-bottom: 30px;\n  opacity: 0.9;\n}\n\n.error-card h2 {\n  font-size: 2.4rem;\n  font-weight: 700;\n  color: #6b1f2a;\n  margin-bottom: 20px;\n  line-height: 1.4;\n  letter-spacing: 0.5px;\n}\n\n.error-card p {\n  font-size: 1.4rem;\n  color: #3d3a3b;\n  font-weight: 500;\n  line-height: 1.7;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .employee-card,\n  .info-section,\n  .barcode-section {\n    max-width: 100%;\n  }\n\n  .info-section {\n    padding: 40px 40px;\n  }\n\n  .info-grid {\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .content-wrapper {\n    box-shadow: none;\n  }\n\n  .public-header {\n    padding: 35px 25px;\n  }\n\n  .header-logos {\n    gap: 35px;\n    margin-bottom: 20px;\n  }\n\n  .republic-logo,\n  .ministry-logo {\n    height: 75px;\n  }\n\n  .main-title {\n    font-size: 2rem;\n  }\n\n  .sub-title {\n    font-size: 1.4rem;\n  }\n\n  .card-header-section {\n    flex-direction: column;\n    padding: 40px 25px;\n    gap: 30px;\n  }\n\n  .basic-info {\n    text-align: center;\n    max-width: 100%;\n  }\n\n  .employee-photo,\n  .photo-placeholder {\n    width: 180px;\n    height: 180px;\n  }\n\n  .employee-name {\n    font-size: 2.2rem;\n    text-align: center;\n  }\n\n  .info-section {\n    padding: 35px 25px;\n  }\n\n  .section-title {\n    font-size: 1.8rem;\n    padding-bottom: 15px;\n  }\n\n  .section-title::after {\n    width: 100px;\n  }\n\n  .info-grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .info-item {\n    padding: 20px 22px;\n  }\n\n  .qr-code {\n    width: 200px;\n    height: 200px;\n  }\n\n  .barcode-section {\n    padding: 45px 25px;\n  }\n\n  .public-footer {\n    padding: 35px 25px;\n  }\n\n  .error-card {\n    margin: 50px 20px;\n    padding: 50px 30px;\n  }\n}\n\n@media (max-width: 480px) {\n  .main-title {\n    font-size: 1.6rem;\n  }\n\n  .sub-title {\n    font-size: 1.2rem;\n  }\n\n  .employee-name {\n    font-size: 1.9rem;\n  }\n\n  .info-value {\n    font-size: 1.3rem;\n  }\n\n  .section-title {\n    font-size: 1.5rem;\n  }\n\n  .info-label {\n    font-size: 0.95rem;\n  }\n\n  .employee-photo,\n  .photo-placeholder {\n    width: 150px;\n    height: 150px;\n  }\n\n  .qr-code {\n    width: 170px;\n    height: 170px;\n  }\n\n  .info-section {\n    padding: 30px 20px;\n  }\n\n  .public-header {\n    padding: 30px 20px;\n  }\n}\n\n/* طباعة */\n@media print {\n  .public-view-container {\n    background: white;\n  }\n\n  .content-wrapper {\n    box-shadow: none;\n  }\n\n  .card-header-section::before,\n  .public-header::before,\n  .public-footer::before,\n  .barcode-section::before {\n    display: none;\n  }\n\n  .employee-card {\n    page-break-inside: avoid;\n  }\n\n  .info-section {\n    page-break-inside: avoid;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
